export default __webpack_public_path__ + "static/media/logo-GRS.ea037f04.png";